<template>
  <div class="transport" :style="divStyle">
    <!--    <el-form-item v-if="!isNeed" :label="label" :prop="prop" class="transportTitle"/>-->
    <div v-if="!isNeed" class="transportTitle">
      <span style="font-weight: 700;"><span style="color:red">*</span>{{ label }}</span>
    </div>
    <div v-else class="transportTitle" style="top:-10px;left:25px;height:20px;padding-left: 10px;">
      {{ label }}
    </div>
    <slot/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      winHeight: 0,
    };
  },
  props: {
    label: {
      default: '',
    },
    prop: {
      default: '',
    },
    divStyle: {
      default: '',
    },
    isNeed: {
      default: false,
    },
  },
  methods: {},
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.transport {
  width: 100%;
  border: 1px solid #C3C3C3;
  position: relative;
  padding: 0 10px;
  margin-bottom: 20px;

  &Title {
    margin-bottom: 0;
    position: absolute;
    top: -12px;
    z-index: 999;
    background-color: #fff;
    left: 20px;
    padding: 0 10px;
    color: #335483;
    font-size: 15px;
    font-weight: 700;

    ::v-deep {
      .el-form-item__label {
        color: rgb(51, 84, 131);
        font-size: 15px;
      }
    }
  }
}
</style>
